import {Notification, MessageBox, Message} from 'element-ui'

class ResponseError {
  showMessage(error) {
    const {data: {msg}, code} = error
    if(msg){
      Message.error(msg)
    }
  }
}

const responseError = new ResponseError()

export default responseError